/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'

import Leaflet from 'leaflet'

import './OrderWay.scss'
import 'leaflet/dist/leaflet.css'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import DeliveryIconUnSelect from '../../assets/svg/DeliveryIcon.svg'
import DeliveryIconSelect from '../../assets/svg/DeliveryIconSelect.svg'

import PlaceIconUnSelect from '../../assets/svg/PlaceIcon.svg'
import PlaceIconSelect from '../../assets/svg/PlaceIconUnSelect.svg'

import { useNavigate } from 'react-router-dom'
import { get, getUrl, post } from '../../services/https'

import iconUrl from '../../assets/svg/Location.svg'

import { useSelector, useStore, useDispatch } from 'react-redux'
import { addToOrderWayAction } from '../../redux/store/orderWay'

import dataJson from '../../data/geo.json'

import { MapContainer, TileLayer, Marker, useMapEvents, GeoJSON } from 'react-leaflet'

export const newicon = new Leaflet.Icon({
  iconUrl,
  iconAnchor: [5, 55],
  popupAnchor: [10, -44],
  iconSize: [45, 55]
})

export default function index() {
  const [data, setData] = useState('')
  const [id, setId] = useState('')
  const [peykButton, setPeyButton] = useState(true)
  const [placeButton, setPlaceButton] = useState(false)

  const [tables, setTables] = useState([])

  const [initialPosition, setInitialPosition] = useState([0,0])
  const [selectedPosition, setSelectedPosition] = useState([0,0])
  const [addresses, setAddresses] = useState([])
  
  const [addressSelect, setAddressSelect] = useState('')
  const [mapLayerStyle, setMapLayerStyle] = useState(false)
  const [addressLayerStyle, setAddressLayerStyle] = useState(false)
  const [plak, setPlak] = useState('')
  const [floor, setFloor] = useState('')
  const [detailAddress, setDetailAddress] = useState('')
  const [tableNameSelected, setTableNameSelected] = useState('')
  const [addressSelected, setAddressSelected] = useState('')
  //if false = peyk true = self
  const [orderType, setOrderType] = useState(false)
 
  const navigate = useNavigate()

  const order = useSelector(state => state.orderWay)
  const dispatch = useDispatch()

  console.log(localStorage.getItem('shopId'))

  if (localStorage.getItem('shopId') === null) {
    navigate('/')
  }

  useEffect(() => {
    get('/api/front/table')
      .then(response => {
        setTables(response.data.data)
      })

    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        setId(response.data.data.userId)
        get(`/api/front/users/${response.data.data.userId}`)
          .then(response => {
            setAddresses(response.data.data.address)
          }).catch(error => {
            notify('error', 'ابتدا ثبت نام / ورود کنید')
            setTimeout(() => {
              navigate('/login')
            }, 3000)
          })
      }).catch(error => {
        // notify('error', 'ابتدا ثبت نام / ورود کنید')
        Swal.fire({
          icon: "error",
          title: "ابتدا ثبت نام کنید یا وارد شوید",
          text: "",
          footer: '<a href="#">در صورت مشکل با پشتیبانی در تماس باشید</a>'
        })
        setTimeout(() => {
          navigate('/login')
        }, 3000)
      })

    get(`/api/front/geo/${localStorage.getItem('shopId')}`).then(response => {
      setData(response.data.data.geoData)
    }).catch(error => {
      notify('error', 'خطا در ارسال اطلاعات')
    })
    
    navigator.geolocation.getCurrentPosition(position => {
      const { latitude, longitude } = position.coords
      setInitialPosition([latitude, longitude])
    })
  }, [navigate])

  const Markers = () => {
    useMapEvents({
      click(e) {        
      },      
    })

    return (
      selectedPosition ? 
        <Marker
          key={selectedPosition[0]}
          position={selectedPosition}
          interactive={false} 
          icon={newicon}
        />
      : null
    )
  }

  const paykHandler = () => {
    setPeyButton(true)
    setPlaceButton(false)
    setOrderType(false)
  }

  const placeHandler = () => {
    setPeyButton(false)
    setPlaceButton(true)
    setOrderType(true)
  }
  
  const position = [37.27579, 49.937]

  const onEachFeature = (feature, layer) => {
    layer.on({
      click: (e) => {
        setSelectedPosition([
          e.latlng.lat,
          e.latlng.lng
        ])

        getUrl('https://map.ir/reverse', {
          params: {
            lat: e.latlng.lat,
            lon: e.latlng.lng,
          },
          headers: {
            'x-api-key': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImEzNjY2ZWQ2YTNkMWZmMzkyNjA0NGY5ODg4MDNlMTkyMTRkMTM1ODlhOTIwMmU0OTMwN2Y3ZWMyZGZjZjZmZjE1ZGI1YmYyN2FiMThjNGQyIn0.eyJhdWQiOiIyNTA0MCIsImp0aSI6ImEzNjY2ZWQ2YTNkMWZmMzkyNjA0NGY5ODg4MDNlMTkyMTRkMTM1ODlhOTIwMmU0OTMwN2Y3ZWMyZGZjZjZmZjE1ZGI1YmYyN2FiMThjNGQyIiwiaWF0IjoxNzAwNjQwMzc2LCJuYmYiOjE3MDA2NDAzNzYsImV4cCI6MTcwMzE0NTk3Niwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.IUMY19HeYGJZN0YLZqX9MxpMryIlGUyL1fDMoA6uxQzHnaVb-6jA_oSFCGimQwkY03f91nYLLO7sZLmRDE6UM8oU3fCGmiarzV8tOlii97ZBTKvPJYOsXZIp7bHfAJxst_uSwOQ-121hLbNBe1nVuRmqWPJoXWKibInvFtoZ8xB34TDfkykNPHKfVA7BXzp-2R830NQrxDm_A4Ar2ra2qYVPqkLV6Dmw8cwIySHuxqYQvDaC4AcnA7AGEqnVzKW7IcoqNoiKjkysji8gO8Sdl6MO8QIS4ZWbOTlPBlGyN-kDOjOGCEjAO1oqOYmoFwGmhGdwr8qLtTcT0Hy_5Xqvvw'
          }
        }).then(response => {
          setAddressSelect(response.data.address_compact)
        }).catch(error => {
          notify('error', 'خطا در ارسال اطلاعات')
        })
      }
    })
  }

  const getLocationHandler = () => {
    if (addressSelect.length === 0) {
      notify('error', 'ابتدا لوکیشن را انتخاب کنید')
    } else {
      setMapLayerStyle(false)
      setAddressLayerStyle(true)
    }
  }

  const submitAddressHandler = () => {
    post('/api/front/users/addAddress', {
        id,
        address: {
          plak, floor, detailAddress, addressSelect, selectedPosition
        }
      }).then(response => {
        if (response.data.success) {
          notify('success', 'آدرس جدید ثبت شد')
          setMapLayerStyle(false)
          setAddressLayerStyle(false)
          get(`/api/front/users/${id}`)
          .then(response => {
            setAddresses(response.data.data.address)
          })
        }
      }).catch(error => {
        console.log(error)
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  const orderButtonHandler = () => {
    dispatch(addToOrderWayAction(
      {
        type: orderType ? 'self' : 'peyk',
        orderDetail: orderType ? tableNameSelected : addressSelected
      }
    ))

    const type = orderType ? 'self' : 'peyk'
    console.log(type)
    if (type === 'peyk') {
      if (addressSelected.length === 0) {
        notify('error', 'یکی از آدرس ها را انتخاب کنید')
      } else {
        navigate('/cardend')
      }
    }

    if (type === 'self') {
      if (tableNameSelected.length === 0) {
        notify('error', 'یکی از میز ها را انتخاب کنید')
      } else {
        navigate('/cardend')
      }
    }
  }

  const selfWayHandler = (e) => {
    setTableNameSelected(e.target.id)
    setOrderType(true)
  }

  const addressWayHandler = (e) => {
    setAddressSelected(JSON.parse(e.target.getAttribute('data')))
    setOrderType(false)
  }

  return (
    <div id='orderWay'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className="mapCountainer" style={addressLayerStyle ? { zIndex: '100' } : { zIndex: '-1' }}>
        <div className="map">
          <div className="title">
            انتخاب آدرس
          </div>
          <div className='formRow'>
            <div className="formColumn">
              <label htmlFor="">آدرس :</label> 
              <input type="text" defaultValue={addressSelect} readOnly />
            </div>
          </div>
          <div className='formRow side'>
            <div className="formColumn">
              <label htmlFor="">پلاک :</label> 
              <input onChange={e => setPlak(e.target.value)} type="text" />
            </div>
            <div className="formColumn">
              <label htmlFor="">واحد :</label> 
              <input onChange={e => setFloor(e.target.value)} type="text" />
            </div>
          </div>
          <div className='formRow'>
            <div className="formColumn">
              <label htmlFor="">توضیحات :</label> 
              <textarea onChange={e => setDetailAddress(e.target.value)} placeholder='' rows={4}></textarea>
            </div>
          </div>
          <button style={{ width: '100%' }} onClick={submitAddressHandler}>ثبت</button>
        </div>
      </div>
      <div className="mapCountainer" style={mapLayerStyle ? { zIndex: '100' } : { zIndex: '-1' }}>
        <div className="map">
          <div className="title">
            انتخاب آدرس (برروی منطقه مورد نظر ضربه بزنید)
          </div>
          <MapContainer 
            center={position} 
            zoom={14}
            >
            <TileLayer
              attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
            />
            {data ? 
              <GeoJSON 
                data={data} 
                onEachFeature={onEachFeature}
                /> : ''}
            <Markers />
          </MapContainer>
          <div className='addressSelected'>
            آدرس : {addressSelect} 
          </div>
          <button style={{ width: '100%' }} onClick={getLocationHandler}>مرحله بعد</button>
        </div>
      </div>
      <div className='scroll'>
        <div className='orderWayTitle'>روش تحویل سفارش</div>
        <div className='orderWaySubtitle'>
          یکی از روش های زیر را انتخاب کنید
        </div>
        <div onClick={paykHandler} className={peykButton ? 'orderWayButtonSelected' : 'orderWayButton'}>
          <div className='text'>
            <span>ارسال توسط پیک</span>
            <span>توسط پیک ارسال می شود</span>
          </div>
          <div className='pic'>
            <img src={peykButton ? DeliveryIconUnSelect : DeliveryIconSelect} alt='Delivery' />
          </div>
        </div>
        <div onClick={placeHandler} className={placeButton ? 'orderWayButtonSelected' : 'orderWayButton'}>
          <div className='text'>
            <span>تحویل حضوری</span>
            <span>خودم در محل تحویل میگیرم</span>
          </div>
          <div className='pic'>
            <img src={placeButton ? PlaceIconSelect : PlaceIconUnSelect} alt='PlaceIcon' />
          </div>
        </div>
        <div className='orderWayAddress' style={peykButton ? { display: '' } : { display: 'none' }}>
          <div className='text'>آدرس‌ها</div>
          <div className='button'>
            <button onClick={() => setMapLayerStyle(true)}>ثبت آدرس جدید</button>
          </div>
        </div>
        <div className='orderWayAddressesMain'>
          <div onClick={selfWayHandler} className='orderWayAddresses' style={placeButton ? { display: '' } : { display: 'none' }}>
            {tables ? tables.map((table, index) => (
              <div className='address' key={index}>
                <input type='radio' name='table' id={table.name} />
                <span id={table.name}>{table.name}</span>
              </div>
            )) : ''}
          </div>
        </div>
        <div className='orderWayAddressesMain'>
          <div onClick={addressWayHandler} className='orderWayAddresses' style={peykButton ? { display: '' } : { display: 'none' }}>
            {addresses ? addresses.map((address, index) => (
              <div className='address' key={index}>
                <input data={JSON.stringify(address)} type='radio' name='address' id='address' />
                <span data={JSON.stringify(address)} name='address' id='address'>{address.addressSelect + ' -  پلاک : ' + address.plak + ' - واحد : ' + address.floor}</span>
              </div>
            )) : (<div className='noAddress'>آدرسی ثبت نشده است</div>)}
          </div>
        </div>
        
        <div className='pay'>
          <button onClick={orderButtonHandler}>ادامه فرآیند خرید</button>
        </div>
      </div>
      <Footer page={'card'} />
    </div>
  )
}
